import { Theme } from '@mui/material/styles';
import { SystemProps } from '@mui/system';
import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { UserAvatar } from 'shared/components/UserAvatar';
import { useStyles } from './EmptyUserCard.styles';

type EmptyUserCardProps = {
  title: string;
  onClick?: () => void;
} & SystemProps<Theme>;

export const EmptyUserCard: FC<EmptyUserCardProps> = ({ title, onClick, ...rest }) => {
  const { classes } = useStyles({ isPointerCursor: Boolean(onClick) });

  return (
    <Box onClick={onClick} className={classes.root} {...rest}>
      <UserAvatar />
      <Typography pl={2}>{title}</Typography>
    </Box>
  );
};
